module.exports = __webpack_public_path__ + "media/images/layouts/boardroom-ed726c566cac81073c8ffffa484189aa.png";